import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';

import { personName } from '../../utils/people_helpers';

import './assigned_users.scss';
import Avatar from '../avatar';
import { TASK_ASSIGNMENT_STATUS } from '../../utils/task';

const AMOUNT_OF_SHOWN_ASSIGNED_USERS = 3;

const AssignedUsers = props => {
  const { assignedPeople } = props;
  const assignedUsersLength = _.size(assignedPeople);
  const showMore = assignedUsersLength > AMOUNT_OF_SHOWN_ASSIGNED_USERS;
  const amountOfRestAvatar = assignedUsersLength - AMOUNT_OF_SHOWN_ASSIGNED_USERS;

  const assignmentStatusCode = assignment => _.get(assignment, 'type_task_user_status.code');
  const hasStatus = (assignment, type) => assignmentStatusCode(assignment) === type;

  if (_.size(assignedPeople) > 0) {
    const mappedUsers = _.map(
      [...assignedPeople].splice(0, AMOUNT_OF_SHOWN_ASSIGNED_USERS),
      (assignment, assignmentIndex) => {
        const assignedPerson = _.get(assignment, 'company_person');
        const fullName = personName(assignedPerson);
        const statusName = _.get(assignment, 'type_task_user_status.name');
        return (
          <Avatar
            key={`assigned-user-${assignmentIndex}`}
            accepted={hasStatus(assignment, TASK_ASSIGNMENT_STATUS.ACCEPTED)}
            assigned={hasStatus(assignment, TASK_ASSIGNMENT_STATUS.ASSIGNED)}
            declined={hasStatus(assignment, TASK_ASSIGNMENT_STATUS.DECLINED)}
            expired={hasStatus(assignment, TASK_ASSIGNMENT_STATUS.EXPIRED)}
            pending={hasStatus(assignment, TASK_ASSIGNMENT_STATUS.PENDING)}
            title={`${fullName}: ${statusName}`}
            person={assignedPerson}
          />
        );
      },
    );
    return (
      <Fragment>
        {mappedUsers}
        {showMore && (
          <span className="assigned-users__more-users layout-box l__has-columns">
            {`+ ${amountOfRestAvatar} more`}
          </span>
        )}
      </Fragment>
    );
  }

  return <span>Unassigned</span>;
};

AssignedUsers.propTypes = {
  assignedPeople: PropTypes.arrayOf(PropTypes.shape({})),
  property: PropTypes.shape({}),
  taskCompany: PropTypes.shape({}),
};

AssignedUsers.defaultProps = {
  assignedPeople: [],
  property: {},
};

const AssignedUsersWrapper = props => (
  <div
    className={classnames('assigned-users layout-box l__has-columns l__align-center', {
      'assigned-users--mobile': props.mobile,
    })}
  >
    {AssignedUsers(props)}
  </div>
);

AssignedUsersWrapper.propTypes = {
  mobile: PropTypes.bool,
};

AssignedUsersWrapper.defaultProps = {
  mobile: false,
};

export default AssignedUsersWrapper;
